import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass, faPhone } from '@fortawesome/free-solid-svg-icons'
import CustomButton from './custom-button'

const ChaseNotFound: React.FC = () => {
    return (
        <div className="w-full max-w-[460px] surface-card px-5 py-8 sm:px-9 sm:py-10 animate-drop-in">
            <div className='flex flex-col items-center justify-center'>
                <span className='w-16 h-16 rounded-2xl bg-[rgba(229,57,53,0.14)] flex items-center justify-center animate-pop'>
                    <FontAwesomeIcon icon={faMagnifyingGlass} className='text-[#FF8A87] text-[24px]' />
                </span>
                <h2 className='text-white text-heroSM sm:text-hero mt-5 text-center'>Chase Not Found</h2>

                <p className='text-body text-white/[0.66] mt-2.5 text-center max-w-[340px]'>We were unable to obtain the require information from you in time, Please urgently call us on the number.</p>

                <CustomButton className='mt-7' onClick={() => { document.location.href = "tel:03300419368" }}>
                    <FontAwesomeIcon icon={faPhone} /> 0330 041 9368
                </CustomButton>
            </div>
        </div>
    )
}

export default ChaseNotFound
